// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__219zE","list":"BalanceDue_list__seTfi","listRow":"BalanceDue_listRow__1bEPq","total":"BalanceDue_total__3-1a0"};